<template>
  <testate :filtraTipiDocumento="filtraTipiDocumento" title="Documenti fornitore" :hideRiepilogativa="true" @apriDettaglio="apriDettaglio"/>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import Testate from './components/testate'

  export default {
    components: {
      Testate
    },
    mixins: [verificaLicenza],
    data: () => ({
      step: 1,
      chiaveDocumento: null,
      filtraTipiDocumento: []
    }),
    async mounted() {
      await this.gestioneToken()
      const tipiDocumento = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
      this.filtraTipiDocumento = tipiDocumento.filter(x => ['ordineFornitore', 'ddtFornitore', 'ordineMultiplo'].includes(x.tipoDocumento))
      this.$store.commit('documenti/SET_PAGE', 'testata')
      await configurazioni.caricaCacheDefault()
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      if (_.get(impostazioni, 'prodotti.abilitaProdottiPreCache', true)) {
        await prodotti.popolaPreCache(true)
      }
    },
    computed: {
      gotoBase() {
        return this.$store.getters['documenti/gotoBase']
      }
    },
    watch: {
      gotoBase(value) {
        if (value) {
          this.step = 1
          this.$store.commit('documenti/CLEAR_GOTO_BASE')
        }
      }
    },
    methods: {
      apriDettaglio(chiave) {
        // console.log('chiave', chiave)
        this.chiaveDocumento = chiave
        this.$store.commit('documenti/SET_PAGE', 'dettaglio')
        this.step = 2
      },
      tornaIndietro() {
        this.step = 1
        this.$store.commit('documenti/SET_PAGE', 'testata')
        this.$store.commit('documenti/SET_CHIAVE', null)
        this.$store.commit('documenti/CLEAR_DOCUMENTO')
        this.chiaveDocumento = null
      }
    }
  }
</script>
